import api from './api';

class RepaymentService {
  async getAllRepayments(params = {}) {
    const response = await api.get('/repayments', { params });
    return response.data;
  }

  async getRepayment(id) {
    const response = await api.get(`/repayments/${id}`);
    return response.data;
  }

  async createRepayment(repaymentData) {
    const response = await api.post('/repayments', repaymentData);
    return response.data;
  }

  async processRepayment(id, paymentData) {
    const response = await api.post(`/repayments/${id}/process`, paymentData);
    return response.data;
  }

  async waivePenalty(id, waiverData) {
    const response = await api.post(`/repayments/${id}/waive-penalty`, waiverData);
    return response.data;
  }

  async getDueRepayments(date) {
    const response = await api.get('/repayments/due', { params: { date } });
    return response.data;
  }

  async getRepaymentSummary() {
    const response = await api.get('/repayments/summary');
    return response.data;
  }
}

export default new RepaymentService();